/* ==========================================================================
   jersey-personalisation.js  (v3 — full 25/26 kit collection)
   Orlando Pirates Official Store

   - Reads config from <script id="op-pers-config">.
   - Letters/numbers auto-discovered per kit (home/third = white, away = black).
   - THREE patch options always shown: No Patch, Betway Premiership Patch - Home,
     Betway Premiership Patch - Away (images hard-coded via theme assets).
   - Live canvas preview (name auto-shrinks to fit; number fixed size).
   - Junior jerseys: only the two largest sizes may be personalised.
   - Adds jersey + each letter/number/patch to the cart in one request,
     grouped by a shared _pers_group property.
   ========================================================================== */
(function () {
  "use strict";

  var cfgEl = document.getElementById("op-pers-config");
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var KC = CFG.kitConfig || {};

  var els = {
    open:    document.querySelector("[data-op-open]"),
    overlay: document.querySelector("[data-op-overlay]"),
    close:   document.querySelector("[data-op-close]"),
    name:    document.getElementById("op-name"),
    number:  document.getElementById("op-number"),
    badges:  document.querySelector("[data-op-badges]"),
    summary: document.querySelector("[data-op-summary]"),
    apply:   document.querySelector("[data-op-apply]"),
    clear:   document.querySelector("[data-op-clear]"),
    error:   document.querySelector("[data-op-error]"),
    info:    document.querySelector("[data-op-info]"),
    canvas:  document.getElementById("op-canvas")
  };

  // Move the overlay to <body> so no header/section stacking context can trap it.
  if (els.overlay && els.overlay.parentNode !== document.body) {
    document.body.appendChild(els.overlay);
  }

  var MAP = { letters: {}, numbers: {}, badges: [] };
  var PRICE = {
    letter: CFG.fallbackPrices.letter,
    number: CFG.fallbackPrices.number,
    badge:  CFG.fallbackPrices.badge
  };
  var selectedBadge = null;
  var ready = false;
  var backImg = null;

  var money = function (cents) {
    return "R" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  };

  /* ----------------------------- data loading ---------------------------- */
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function indexByOption(product) {
    var out = {};
    if (!product) return out;
    product.variants.forEach(function (v) {
      var key = String(v.option1 == null ? v.title : v.option1).trim().toUpperCase();
      out[key] = { id: v.id, available: v.available, price: v.price };
    });
    return out;
  }

  function loadComponents() {
    var patches = CFG.patches || [];
    var jobs = [fetchProduct(KC.letters), fetchProduct(KC.numbers)]
      .concat(patches.map(function (p) { return fetchProduct(p.handle); }));

    return Promise.all(jobs).then(function (res) {
      var lettersP = res[0], numbersP = res[1];
      MAP.letters = indexByOption(lettersP);
      MAP.numbers = indexByOption(numbersP);

      if (lettersP && lettersP.variants[0]) PRICE.letter = lettersP.variants[0].price;
      if (numbersP && numbersP.variants[0]) PRICE.number = numbersP.variants[0].price;

      // Always build all patch options; image is hard-coded from config,
      // id + price come from the live product (fallback until published).
      MAP.badges = patches.map(function (p, i) {
        var prod = res[2 + i];
        var v = prod && prod.variants && prod.variants[0];
        return {
          name: p.name,
          id: v ? v.id : null,
          available: v ? v.available : true,
          price: v ? v.price : CFG.fallbackPrices.badge,
          image: p.image || null
        };
      });

      ready = Object.keys(MAP.letters).length > 0 && Object.keys(MAP.numbers).length > 0;
      return ready;
    });
  }

  /* ----------------------------- input helpers --------------------------- */
  function normaliseName(s) {
    return (s || "").toUpperCase().replace(/[^A-Z]/g, "").slice(0, CFG.limits.maxLetters);
  }
  function normaliseNumber(s) {
    return (s || "").replace(/[^0-9]/g, "").slice(0, CFG.limits.maxNumbers);
  }
  function countChars(str) {
    var m = {}; for (var i = 0; i < str.length; i++) { m[str[i]] = (m[str[i]] || 0) + 1; } return m;
  }

  function validate(name, number) {
    var errs = [];
    if (name.length < CFG.limits.minLetters) errs.push("Name must be at least " + CFG.limits.minLetters + " letters.");
    if (number.length < 1) errs.push("Enter a number (1–2 digits).");

    var oos = [];
    Object.keys(countChars(name)).forEach(function (ch) {
      if (!MAP.letters[ch] || !MAP.letters[ch].available) oos.push("letter " + ch);
    });
    Object.keys(countChars(number)).forEach(function (ch) {
      if (!MAP.numbers[ch] || !MAP.numbers[ch].available) oos.push("number " + ch);
    });
    if (selectedBadge && selectedBadge.id && !selectedBadge.available) oos.push("patch “" + selectedBadge.name + "”");
    if (oos.length) errs.push("Temporarily out of stock: " + oos.join(", ") + ". Please adjust and try again.");
    return errs;
  }

  /* ------------------------- junior size eligibility --------------------- */
  function currentSize() {
    var id = selectedJerseyVariantId();
    if (!id || !CFG.variantSizes) return null;
    return CFG.variantSizes[String(id)] || null;
  }
  function eligibleSize() {
    if (!CFG.isJunior) return true;
    var s = currentSize();
    if (!s) return true; // unknown — re-checked at apply
    return (CFG.juniorAllowedSizes || []).indexOf(s) > -1;
  }

  /* ------------------------------- pricing ------------------------------- */
  function pricing(name, number) {
    var badgeCents = (selectedBadge ? selectedBadge.price : 0) || 0;
    return {
      letters: name.length, numbers: number.length, badgeCents: badgeCents,
      cents: name.length * PRICE.letter + number.length * PRICE.number + badgeCents
    };
  }

  function renderSummary() {
    var name = normaliseName(els.name.value), number = normaliseNumber(els.number.value);
    var p = pricing(name, number);
    var rows = "";
    rows += row("Letters (" + p.letters + " × " + money(PRICE.letter) + ")", money(p.letters * PRICE.letter));
    rows += row("Number (" + p.numbers + " × " + money(PRICE.number) + ")", money(p.numbers * PRICE.number));
    if (selectedBadge) rows += row(selectedBadge.name, money(p.badgeCents));
    rows += "<div class='op-pers-row total'><span>Personalisation total</span><span>" + money(p.cents) + "</span></div>";
    els.summary.innerHTML = rows;
    function row(l, r) { return "<div class='op-pers-row'><span>" + l + "</span><span>" + r + "</span></div>"; }
  }

  /* ------------------------------- badges -------------------------------- */
  function renderBadges() {
    if (!MAP.badges.length) { els.badges.innerHTML = "<div class='op-pers-note'>No patch available.</div>"; return; }
    var html = badgeRow(null, "No Patch", 0, true, null);
    MAP.badges.forEach(function (b, i) { html += badgeRow(i, b.name, b.price, b.available, b.image); });
    els.badges.innerHTML = html;
    Array.prototype.forEach.call(els.badges.querySelectorAll("input[name=op-badge]"), function (input) {
      input.addEventListener("change", function () {
        var idx = input.value === "" ? null : parseInt(input.value, 10);
        selectedBadge = idx === null ? null : MAP.badges[idx];
        Array.prototype.forEach.call(els.badges.querySelectorAll(".op-pers-badge"), function (c) { c.classList.remove("is-active"); });
        input.closest(".op-pers-badge").classList.add("is-active");
        renderSummary();
      });
    });

    function badgeRow(idx, label, price, available, image) {
      var val = idx === null ? "" : idx;
      var priceTxt = idx === null ? "Free" : money(price);
      var dis = available ? "" : "disabled";
      var soldout = available ? "" : " <span style='color:#c0392b;font-weight:500'>(out of stock)</span>";
      var img = image
        ? "<img src='" + image + "' alt='' onerror=\"this.style.display='none'\" style='width:52px;height:52px;object-fit:contain;flex:0 0 auto;background:#fff;border:1px solid #eee;border-radius:8px;padding:2px'>"
        : "";
      // Order: radio, name, patch image (hard-coded), price.
      return "<label class='op-pers-badge" + (idx === null ? " is-active" : "") + "' style='display:flex;align-items:center;gap:12px'>" +
        "<input type='radio' name='op-badge' value='" + val + "' " + (idx === null ? "checked" : "") + " " + dis + " style='flex:0 0 auto;margin:0;width:18px;height:18px;accent-color:#111'>" +
        "<span class='op-b-name' style='flex:1 1 auto;font-weight:600;font-size:14px'>" + label + soldout + "</span>" +
        img +
        "<span class='op-b-price' style='flex:0 0 auto;font-weight:700;font-size:14px;white-space:nowrap'>" + priceTxt + "</span>" +
      "</label>";
    }
  }

  /* ------------------------------- preview ------------------------------- */
  function draw() {
    if (!els.canvas) return;
    var ctx = els.canvas.getContext("2d");
    var maxW = CFG.previewMaxWidth || 500;
    var iw = (backImg && backImg.naturalWidth) ? backImg.naturalWidth : maxW;
    var ih = (backImg && backImg.naturalHeight) ? backImg.naturalHeight : maxW;
    var w = Math.min(iw, maxW);
    var h = Math.round(w * (ih / iw));
    els.canvas.width = w; els.canvas.height = h;
    ctx.clearRect(0, 0, w, h);

    if (backImg && backImg.complete && backImg.naturalWidth) {
      ctx.drawImage(backImg, 0, 0, w, h);
    } else {
      ctx.fillStyle = "#111"; ctx.fillRect(0, 0, w, h);
    }

    var name = normaliseName(els.name.value), number = normaliseNumber(els.number.value);
    ctx.fillStyle = KC.textColor || "#FFFFFF"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    if (name) {
      var up = name.toUpperCase();
      var minNs = KC.nameMinFontSize || 26;
      // 1) Step the size down for every letter beyond the "full size" threshold.
      var base = KC.nameFontSize || 72;
      var fullUpTo = KC.nameFullUpTo || 5;      // this many letters stay full size
      var step = KC.nameStepPerChar || 8;       // px smaller per extra letter
      var ns = base - (Math.max(0, up.length - fullUpTo) * step);
      if (ns < minNs) ns = minNs;
      // 2) Safety clamp: never wider than the shirt body.
      var maxNameW = w * (KC.nameMaxWidthPct || 0.55);
      ctx.font = 'bold ' + ns + 'px "Roboto Condensed", Arial, sans-serif';
      while (ns > minNs && ctx.measureText(up).width > maxNameW) {
        ns -= 2;
        ctx.font = 'bold ' + ns + 'px "Roboto Condensed", Arial, sans-serif';
      }
      ctx.fillText(up, w * KC.namePosition.x, h * KC.namePosition.y);
    }
    if (number) {
      // Big; clamp so a 2-digit number never spills off the shirt body.
      var nf = KC.numberFontSize || 150;
      var nmin = KC.numberMinFontSize || 60;
      var maxNumW = w * (KC.numberMaxWidthPct || 0.42);
      ctx.font = 'bold ' + nf + 'px "Roboto Condensed", Arial, sans-serif';
      while (nf > nmin && ctx.measureText(number).width > maxNumW) {
        nf -= 2;
        ctx.font = 'bold ' + nf + 'px "Roboto Condensed", Arial, sans-serif';
      }
      ctx.fillText(number, w * KC.numberPosition.x, h * KC.numberPosition.y);
    }
  }

  function loadBackImage() {
    if (!KC.backImageUrl) { draw(); return; }
    backImg = new Image();
    backImg.onload = draw;
    backImg.onerror = draw;
    backImg.src = KC.backImageUrl;
    if (document.fonts && document.fonts.load) {
      document.fonts.load('bold 140px "Roboto Condensed"').then(draw).catch(function () {});
    }
  }

  /* --------------------------- jersey variant ---------------------------- */
  // Only accept a variant that belongs to THIS product, so the personalisation
  // never attaches to a "you may also like" / recommended product form.
  function ownVariantIds() {
    var mine = {};
    Object.keys(CFG.variantSizes || {}).forEach(function (k) { mine[String(k)] = true; });
    return mine;
  }
  function selectedJerseyVariantId() {
    var mine = ownVariantIds();
    var ids = Object.keys(mine);
    // No config for this product -> NEVER guess. This stops personalisation from
    // ever attaching to a recommended/other product's form (e.g. a bucket hat).
    if (!ids.length) return null;

    // 1) URL ?variant= but ONLY if it belongs to this product
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m && mine[m[1]]) return parseInt(m[1], 10);

    // 2) an add-to-cart form whose selected id belongs to THIS product
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var inp = forms[i].querySelector('[name="id"]');
      if (inp && inp.value && mine[String(inp.value)]) return parseInt(inp.value, 10);
    }

    // 3) single-variant product
    if (ids.length === 1) return parseInt(ids[0], 10);

    // 4) Known product but no OWN variant selected here -> ask for a size.
    //    NEVER fall back to another product's form.
    return null;
  }

  /* ------------------------------ cart add ------------------------------- */
  function buildItems(jerseyId, name, number, groupId) {
    var items = [];
    var jp = { "Name": name, "Number": number, "_pers_group": groupId };
    jp["Patch"] = selectedBadge ? selectedBadge.name : "None";
    items.push({ id: jerseyId, quantity: 1, properties: jp });

    var lc = countChars(name);
    Object.keys(lc).sort().forEach(function (ch) {
      items.push({ id: MAP.letters[ch].id, quantity: lc[ch],
        properties: { "_pers_group": groupId, "_component": "letter", "_char": ch } });
    });
    var nc = countChars(number);
    Object.keys(nc).sort().forEach(function (ch) {
      items.push({ id: MAP.numbers[ch].id, quantity: nc[ch],
        properties: { "_pers_group": groupId, "_component": "number", "_char": ch } });
    });
    if (selectedBadge && selectedBadge.id) {
      items.push({ id: selectedBadge.id, quantity: 1,
        properties: { "_pers_group": groupId, "_component": "patch", "_char": selectedBadge.name } });
    }
    return items;
  }

  // NOTE: the order note is NOT written here. It is regenerated from the actual
  // cart contents on the cart page (personalisation-cart-cleanup.liquid), so it
  // always reflects only the final personalisations — re-doing a name/number/
  // patch never leaves stale lines behind.

  // If an add partially succeeded before a stock rejection, remove anything from
  // this group so no letters/numbers/patch are left stranded in the cart.
  function cleanupGroup(groupId) {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = cart.items
          .filter(function (i) { return i.properties && i.properties._pers_group === groupId; })
          .map(function (i) { return i.key; });
        if (!keys.length) return;
        var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ updates: updates })
        });
      }).catch(function () {});
  }

  function showError(msg) { els.error.hidden = false; els.error.textContent = msg; }
  function clearError() { els.error.hidden = true; els.error.textContent = ""; }

  function apply() {
    clearError();
    if (CFG.isJunior && !eligibleSize()) {
      showError("Junior personalisation is only available in the two largest sizes (" + (CFG.juniorAllowedSizes || []).join(", ") + "). Please choose one of those sizes.");
      return;
    }
    var name = normaliseName(els.name.value), number = normaliseNumber(els.number.value);
    var errs = validate(name, number);
    if (errs.length) { showError(errs[0]); return; }

    var jerseyId = selectedJerseyVariantId();
    if (!jerseyId) { showError("Please choose a size first."); return; }
    // Hard safety net: refuse to personalise anything that is NOT one of this
    // product's own variants, no matter how jerseyId was resolved.
    if (!ownVariantIds()[String(jerseyId)]) { showError("Please choose a size first."); return; }

    var groupId = "OP-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 7);
    var items = buildItems(jerseyId, name, number, groupId);

    els.apply.disabled = true; els.apply.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) {
        var d = (j && (j.description || j.message)) || "";
        var err = new Error(d || "Could not add to cart.");
        // Shopify returns 422 when an item exceeds available stock.
        if (r.status === 422 || /can only add|out of stock|sold out|in stock|not enough|available/i.test(d)) err.stock = true;
        throw err;
      });
      return r.json();
    }).then(function () {
      window.location.href = "/cart";
    }).catch(function (e) {
      if (e && e.stock) {
        showError("Sorry — we don't have enough stock of one of the letters or numbers in this name/number, so we can't add it right now. Please try a different name or number.");
        cleanupGroup(groupId);
      } else {
        showError((e && e.message) || "Something went wrong. Please try again.");
      }
      els.apply.disabled = false; els.apply.textContent = "Add Personalised Jersey to Cart";
    });
  }

  /* ------------------------------- state --------------------------------- */
  // Show the "Personalise Your Jersey" button ONLY when the selected size is
  // eligible. Junior jerseys: only the two largest sizes. Non-junior: always.
  function refreshTrigger() {
    var show = !CFG.isJunior || eligibleSize();
    els.open.style.display = show ? "" : "none";
    // If the size changed to an ineligible one while the modal was open, close it.
    if (!show && els.overlay.classList.contains("is-open")) closeModal();
  }

  function refreshState() {
    if (CFG.isJunior && !eligibleSize()) {
      els.info.hidden = false;
      els.info.textContent = "Junior personalisation is only available in the two largest sizes (" + (CFG.juniorAllowedSizes || []).join(", ") + "). Please choose one of those sizes.";
      els.apply.disabled = true;
      return;
    }
    els.info.hidden = true;
    els.apply.disabled = false;
  }

  function refresh() { refreshTrigger(); refreshState(); }

  /* ------------------------------- wiring -------------------------------- */
  function openModal() { els.overlay.classList.add("is-open"); els.overlay.setAttribute("aria-hidden", "false"); draw(); refreshState(); }
  function closeModal() { els.overlay.classList.remove("is-open"); els.overlay.setAttribute("aria-hidden", "true"); }

  function bindInputs() {
    els.name.addEventListener("input", function () {
      els.name.value = normaliseName(els.name.value); renderSummary(); draw(); clearError();
    });
    els.number.addEventListener("input", function () {
      els.number.value = normaliseNumber(els.number.value); renderSummary(); draw(); clearError();
    });
    els.clear.addEventListener("click", function () {
      els.name.value = ""; els.number.value = ""; selectedBadge = null;
      var none = els.badges.querySelector('input[value=""]'); if (none) none.checked = true;
      Array.prototype.forEach.call(els.badges.querySelectorAll(".op-pers-badge"), function (c, i) {
        c.classList.toggle("is-active", i === 0);
      });
      renderSummary(); draw(); clearError();
    });
    els.apply.addEventListener("click", apply);
  }

  els.open.addEventListener("click", openModal);
  els.close.addEventListener("click", closeModal);
  els.overlay.addEventListener("click", function (e) { if (e.target === els.overlay) closeModal(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });
  // Re-check size eligibility whenever the variant/size selector changes.
  var pform = document.querySelector('form[action*="/cart/add"]');
  if (pform) {
    pform.addEventListener("change", refresh);
    pform.addEventListener("click", function () { setTimeout(refresh, 60); });
  }

  bindInputs();
  renderBadges();
  renderSummary();
  loadBackImage();
  refresh();

  loadComponents().then(function () {
    renderBadges();
    renderSummary();
    refresh();
  });
})();